export default {
    loading: false,
    document: null,
    pdfUrl: null,
    error: null,
    showModal: false
};



// WEBPACK FOOTER //
// ./src/modules/public-invoice/state.js